import { getInfo, getMenus } from "@/api/layout";
import { message } from "ant-design-vue";
import { localRemove, localSet } from "@/utils/common-method";

const actions = {
  set_userinfo({ commit }) {
    return new Promise((resolve, reject) => {
      getInfo().then((res) => {
        if (res) {
          if (res.code === 200) {
            resolve(res.result);
            commit("SET_USERINFO", res.result || null);
            localSet("USERINFO", res.result || null);
          } else {
            reject(res.message || "获取用户信息失败");
          }
        } else {
          // reject("获取用户信息失败");
          getMe(commit, { ZT: 1 });
          commit("SET_USERINFO", null);
          localRemove("USERINFO");
        }
      });
    });
  },
  set_token({ commit }, token) {
    commit("SET_TOKEN", token);
    localSet("TOKEN", token);
  },
  set_menus({ commit }, pyload) {
    getMe(commit, pyload);
  },
};

const getMe = (commit, pyload) => {
  getMenus(pyload).then((res) => {
    if (res) {
      if (res.code === 200) {
        commit("SET_MENUS", res.result || []);
        localSet("MENUS", res.result || []);
      } else {
        message.error(res.message || "获取菜单失败");
      }
    } else {
      commit("SET_MENUS", []);
      localRemove("MENUS");
    }
  });
};

export default actions;
